module.exports = __webpack_public_path__ + "static/media/std-profiler.4d00644a.png";